import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  formContainer: {},
  viviendaInnerContainer: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '900px',
    },
  },
  innerContainer: {
    padding: '20px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      width: '95%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'center',
      borderRadius: '20px',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      gap: theme.spacing(2),
      padding: '40px 20px',
    },
  },
  firtInputElement: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
      minWidth: 0,
    },
  },
  inputPrecio: {
    width: '100%',
  },
  engancheInput: {
    width: '100%',
  },
  secondInputElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
    },
  },
  thirdInputElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderTop: '3px solid #dedeeb',
    [theme.breakpoints.up('md')]: {
      borderTop: '0px',
      // margin: '40px 0px 40px 0px',
    },
  },
  precioContainer: {
    flex: 0.7,
    // marginRight: '10px',
  },
  enganche: {
    textAlign: 'center',
    minWidth: theme.spacing(4),
    // borderLeft: '1px solid #E9E9E9',
    // borderRight: '1px solid #E9E9E9',
    // paddingLeft: '3px',
    // paddingRight: '3px',
  },
  invalidate: {
    color: 'red',
  },
  yearContainer: {
    [theme.breakpoints.up('md')]: {
      flex: 0.5,
      minWidth: 0,
    },
  },

  hidden: {
    display: 'none',
  },
  borderRight: {
    borderRight: '3px solid #dedeeb',
    [theme.breakpoints.up('md')]: {
      borderRight: '2px solid #dedeeb',
      borderLeft: '2px solid #dedeeb',
    },
  },
  element: {
    flex: 1,
    padding: '12px 0px 12px 0px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  containerButton: {
    textAlign: 'center',
  },
  button: {
    marginTop: '70px',
    marginBottom: '50px',
    fontSize: '18px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: '700',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#000',
    backgroundColor: '#FFA500',
    padding: '20px 44px',
    textTransform: 'capitalize',
    borderRadius: '40px',
    '&:hover': {
      backgroundColor: '#FFA500',
      opacity: '0.6',
    },
    [theme.breakpoints.up('md')]: {
      backgroundColor: '#FFA500',
      marginTop: '70px',
      marginBottom: '70px',
    },
  },
  engancheContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    borderLeft: '1px solid #E9E9E9',
    paddingLeft: '3px',
  },
  addButton: {
    // padding: theme.spacing(0.5),
    padding: '0px',
  },
  removeButton: {
    // padding: theme.spacing(0.5),
    padding: '0px',
  },
  inputYear: {
    width: '100%',
    padding: '0px',
  },
}));
